import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  type: '',
  message: '',
  show: false,
  notificationTab: false,
  messageNotification: false
}

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setMessageNotification: (state, {payload})=> {
      state.messageNotification = payload;
    },
    setNotification: (state, action)=> {
      state.type = action.payload.type;
      state.message = action.payload.message;
      state.show = action.payload.message? true : false;
    },
    notificationTabOpen: (state, action)=> {
      state.notificationTab = action.payload;
    }
  }
});

export const {
  setNotification,
  notificationTabOpen,
  setMessageNotification
} = notificationSlice.actions;
export const selectNotification = (state) => state.notification;
export default notificationSlice.reducer;